import React from 'react';
import { authRoles } from 'app/auth';
import DashboardRouter from './DashboardRouter';

export const DashboardConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.user,
	routes: [
		{
			path: '/dashboard',
			exact: true,
			component: DashboardRouter
		}
	]
};
